import { graphql } from 'babel-plugin-relay/macro';
import {
  MultipleChoiceExerciseContentInput,
  UpdateMultipleChoiceExerciseMutation,
} from './__generated__/UpdateMultipleChoiceExerciseMutation.graphql';
import { commitMutationPromise } from '../lib/graphqlUtils';
import { updateExerciseUpdater } from './helpers/exerciseMutationHelpers';
const mutation = graphql`
  mutation UpdateMultipleChoiceExerciseMutation(
    $input: UpdateMultipleChoiceExerciseInput!
  ) {
    updateMultipleChoiceExercise(input: $input) {
      exercise {
        id
        content {
          prompt
          choices {
            isCorrect
            text
          }
        }
      }
    }
  }
`;
type fields = {
  content?: MultipleChoiceExerciseContentInput | null;
  position?: number | null;
};

const commit = (
  environment: any,
  id: string,
  worksheetId: string,
  fields: fields,
) =>
  commitMutationPromise<UpdateMultipleChoiceExerciseMutation>(environment, {
    mutation,
    variables: {
      input: {
        id,
        ...fields,
      },
    },
    optimisticUpdater: updateExerciseUpdater(
      'MultipleChoiceExercise',
      id,
      worksheetId,
      fields,
    ),
    updater: updateExerciseUpdater(
      'MultipleChoiceExercise',
      id,
      worksheetId,
      fields,
    ),
  });

export default {
  commit,
};
